export const INCIDENTS_LOAD = 'INCIDENTS_LOAD';
export const INCIDENTS_ADD_NEW = 'INCIDENTS_ADD_NEW';
export const INCIDENTS_UPDATE = 'INCIDENTS_UPDATE';
export const INCIDENTS_CLEAR = 'INCIDENTS_CLEAR';
export const INCIDENTS_DELETE = 'INCIDENTS_DELETE';
export const INCIDENTS_LOAD_EVENT_TYPES = 'INCIDENTS_LOAD_EVENT_TYPES';
export const INCIDENTS_CALENDAR_CHANGE_DATE = 'INCIDENTS_CALENDAR_CHANGE_DATE';
export const INCIDENTS_CALENDAR_CHANGE_VIEW = 'INCIDENTS_CALENDAR_CHANGE_VIEW';
export const INCIDENTS_CALENDAR_RESET = 'INCIDENTS_CALENDAR_RESET';
export const INCIDENTS_SET_KEYWORD = 'INCIDENTS_SET_KEYWORD';
